/**
 * Expose all endpoints for 'reports'.
 */
export const actionPlansApiMock = () => ({
  // descarga un archivo
  getActionPlansDashboard: () =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve({
          data: [
            {
              logicalLocationId: null,
              logicalLocationDescription: null,
              geoLocationId: 2006,
              geoLocationDescription: 'OLG Leon',
              progress: 35,
              indicatorId: null,
              indicatorDescription: null,
              distinctGeoLocations: 1
            },
            {
              logicalLocationId: null,
              logicalLocationDescription: null,
              geoLocationId: 2005,
              geoLocationDescription: 'OLG Anahuac',
              progress: 67.1,
              indicatorId: null,
              indicatorDescription: null,
              distinctGeoLocations: 3
            },
            {
              logicalLocationId: null,
              logicalLocationDescription: null,
              geoLocationId: 2002,
              geoLocationDescription: 'OLG Anahuac',
              progress: 90.1,
              indicatorId: null,
              indicatorDescription: null,
              distinctGeoLocations: 0
            },
            {
              logicalLocationId: null,
              logicalLocationDescription: null,
              geoLocationId: 2003,
              geoLocationDescription: 'OLG Anahuac',
              progress: 80.1,
              indicatorId: null,
              indicatorDescription: null,
              distinctGeoLocations: 3
            }
          ],
          ok: true
        });
      }, 1000);
    }),
  getIndicators: () =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve({
          data: [
            {
              id: 1,
              description: 'indicator1'
            },
            {
              id: 2,
              description: 'indicator2'
            }
          ],
          ok: true
        });
      }, 1000);
    }),
  getTemplates: () =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve({
          data: [
            {
              id: 1,
              name: 'AMBIENTE_MOBILIARIO',
              description: 'El mobiliario no estaba en buen estado',
              indicatorId: 1,
              indicatorDescription: 'Ambiente',
              indicatorName: 'ENVIRONMENT',
              activities: [
                'Reporta a tu director los daños encontrados en el inmueble para determinar soluciones.'
              ]
            },
            {
              id: 4,
              name: 'AMBIENTE_TEMPERATURA',
              description: 'El lugar estaba muy frío/caluroso',
              indicatorId: 1,
              indicatorDescription: 'Ambiente',
              indicatorName: 'ENVIRONMENT',
              activities: [
                'Verificar que se cumplan los estándares de temperatura y adaptarse a la necesidad de la mayoría de los invitados.'
              ]
            },
            {
              id: 5,
              name: 'AMBIENTE_LIMPIEZA',
              description: 'El restaurante no estaba totalmente limpio',
              indicatorId: 1,
              indicatorDescription: 'Ambiente',
              indicatorName: 'ENVIRONMENT',
              activities: [
                'Verificar de manera periódica la limpieza del salón y los baños.'
              ]
            },
            {
              id: 100,
              name: 'ALIMENTOS_TEMPERATURA',
              description: 'Los alimentos estaban muy fríos/calientes',
              indicatorId: 2,
              indicatorDescription: 'Comida',
              indicatorName: 'FOOD',
              activities: ['Controlar la temperatura de los platillos.']
            },
            {
              id: 201,
              name: 'SERVICIO_SONREIR',
              description: 'Atención y amabilidad por parte del personal',
              indicatorId: 3,
              indicatorDescription: 'Servicio',
              indicatorName: 'SERVICE',
              activities: [
                'Supervisa constantemente el área y recuérdale que debe sonreír al invitado en todo momento.'
              ]
            },
            {
              id: 202,
              name: 'SERVICIO_DISPONIBILIDAD',
              description: 'Tiempos de espera',
              indicatorId: 3,
              indicatorDescription: 'Servicio',
              indicatorName: 'SERVICE',
              activities: [
                'Cada server debe estar disponible siempre en su estación y siempre debe de haber por lo menos un server en la zona, siempre se debe buscar anticiparse a las necesidades de los invitados'
              ]
            },
            {
              id: 203,
              name: 'SERVICIO_TIEMPOS COCINA',
              description: 'Tiempos de espera',
              indicatorId: 3,
              indicatorDescription: 'Servicio',
              indicatorName: 'SERVICE',
              activities: [
                'El server siempre se debe de anticipar a los tiempos del invitado y el gerente debe revisar periódicamente el "ticket time" en cocina.'
              ]
            },
            {
              id: 204,
              name: 'SERVICIO_SUPERVISION',
              description: 'Atención y amabilidad por parte del personal',
              indicatorId: 3,
              indicatorDescription: 'Servicio',
              indicatorName: 'SERVICE',
              activities: [
                'Los encargados de piso y el gerente deben realizar una supervisión constante, siempre debe de haber por lo menos un server en la zona y siempre se debe buscar anticiparse a las necesidades de los invitados.'
              ]
            },
            {
              id: 205,
              name: 'SERVICIO_CUENTA',
              description: 'La cuenta estaba incorrecta',
              indicatorId: 3,
              indicatorDescription: 'Servicio',
              indicatorName: 'SERVICE',
              activities: [
                'Capacitar al personal para el manejo de Micros y el server debe verificar que la cuenta sea correcta antes de llevarla al invitado'
              ]
            },
            {
              id: 206,
              name: 'SERVICIO_MENU',
              description: 'El mesero no tenía buen conocimiento del menú',
              indicatorId: 3,
              indicatorDescription: 'Servicio',
              indicatorName: 'SERVICE',
              activities: [
                'Realizar un repaso atento del menú y los platillos durante las juntas de preservicio. Realizar el examen de conocimiento del menú a todos los ME.'
              ]
            }
          ],
          ok: true
        });
      }, 1000);
    }),
  getActionPlanDetails: () =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve({
          data: [
            {
              id: 5012151,
              code: null,
              description: 'Test Action Plan',
              createdAt: '2019-07-04T14:15:34.891Z',
              createdBy: null,
              finalizedAt: null,
              finalizedBy: null,
              actionPlanStatus: 'ACTIVE',
              initialIndicatorValue: null,
              finalIndicatorValue: null,
              geoLocationId: 2022,
              logicalLocationId: 5,
              geoLocationCode: '006001',
              geoLocationDescription: 'OLG Malecon Cancun',
              logicalLocationCode: '003',
              logicalLocationDescription: 'Olive Garden',
              indicatorId: 1,
              indicatorDescription: 'Ambiente',
              actionPlanActivities: [
                {
                  id: 5012201,
                  code: null,
                  description: 'Activity 1',
                  dateFrom: '2019-07-04T14:15:34.891Z',
                  dateTo: '2019-07-04T14:15:34.891Z',
                  responsable: 'Aldo',
                  support: 'soporte',
                  progress: 75,
                  actionPlanId: 5012151
                },
                {
                  id: 5012202,
                  code: null,
                  description: 'Activity 2',
                  createdAt: '2019-07-04T14:15:34.891Z',
                  createdBy: '2019-08-04T14:15:34.891Z',
                  responsable: 'Aldo',
                  support: 'soporte',
                  dateFrom: '2019-07-04T14:15:34.891Z',
                  dateTo: '2019-07-04T14:15:34.891Z',
                  progress: 33,
                  actionPlanId: 5012151
                }
              ]
            }
          ],
          ok: true
        });
      }, 1000);
    })
});

export const actionPlansApi = api => ({
  // el api recibe el nombre del reporte en el path y como query parameters los filtros
  // la lista de nombres de reporte soportados viene en el ca,po 'reports' de account
  getActionPlansDashboard: ({ filters }) => {
    return api.get('action-plans/dashboard', { ...filters });
  },
  getTemplates: () => {
    return api.get('action-plan-templates');
  },
  getActionPlanDetails: ({ filters }) => {
    return api.get('action-plans', { ...filters });
  },
  getIndicators: filters => {
    return api.get('indicators', { ...filters });
  },
  addActionPlan: body => {
    console.log(body, 'body');
    return api.post('action-plans', body);
  },
  updateProgress: ({ actionPlanId, actionPlanActivityId, newValue }) => {
    return api.put(
      `action-plans/${actionPlanId}/activities/${actionPlanActivityId}/progress`,
      { progress: newValue }
    );
  },
  updateStatus: ({ actionPlanId, actionPlanStatus }) => {
    return api.put(`action-plans/${actionPlanId}`, { actionPlanStatus });
  }
});



// WEBPACK FOOTER //
// ./src/services/api/actionPlansApi.js